'use strict';

class RecurringInternationalDraft {
  constructor($scope, $filter, $location, $routeParams, commonService, recipientService, recurringService, originatorService, userService, Notification) {
    this.$scope = $scope;
    this.$filter = $filter;
    this.$location = $location;
    this.commonService = commonService;
    this.recipientService = recipientService;
    this.recurringService = recurringService;
    this.originatorService = originatorService;
    this.userService = userService;
    this.Notification = Notification;

    this.number = $routeParams.number;
    this.alert = {};
  }

  $onInit() {
    this.summaryCalculated = false;

    this.displayContractNumber = false;
    this.displayProjectReference = false;
    this.accountNumbers = [];

    this.defaults = null;

    this.taxRates = [];

    this.currencies = [{
      code: 'NOK',
      name: 'Norske kroner',
      rate: 1
    }];

    this.currency = this.currencies[0];

    this.i18n = {
      QUANTITY: 'Quantity',
      CODE: 'Product',
      DESCRIPTION: 'Description',
      UNITPRICE: 'Price',
      DISCOUNT: 'Disc. %',
      TAXRATE: 'VAT',
      TOTAL: 'Sum'
    };

    this.countries = ['NORGE'];
    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });

    this.commonService.getExchangeRates()
      .then((resp) => {
        this.currencies = resp;
      });

    // get taxRates
    this.commonService.getConstants()
      .then((resp) => {
        this.taxRates = resp.taxRates;
        // let ar = Array.apply(null, new Array(this.taxRates.length)).map(Number.prototype.valueOf, 0);
        let l = this.taxRates.length;
        // let net = Array(l).fill(0);
        // let tax = Array(l - 1).fill(0);
        let net = Array.apply(null, new Array(l)).map(Number.prototype.valueOf, 0);
        let tax = Array.apply(null, new Array(l - 1)).map(Number.prototype.valueOf, 0);

        if (!this.summaryCalculated) {
          this.summary = {
            net: net,
            tax: tax,
            total: 0,
            taxRates: this.taxRates
          };
        }
      });

    this.recurring = {
      name: null,
      comment: null,
      dueDate: 'firstNextMonth',
      shipment: {
        preferred: 'email',
        frequency: 'month',
        copyEmail: null,
        dates: {
          next: moment().format('YYYY-MM-DD'),
          stop: null
        }
      },
      invoice: {
        invoiceText: null,
        accountNumber: null,
        orderReference: null,
        ourReference: null,
        yourReference: null,
        recipient: {
          number: null
        },
        items: [],
        interpolation: {
          date: 'dueDate'
        },
        giroLayout: false
      }
    };

    this.originator = {};
    this.recipient = {
      settings: {
        discount: 0
      },
      contact: {
        mobile: null
      }
    };
    this.summary = {
      net: [0, 0, 0, 0, 0],
      tax: [0, 0, 0, 0],
      total: 0,
      taxRates: []
    };
    this.taxEnabled = false;
    this.SMSNotification = false;

    // datepicker
    this.commonService.datePicker({
      field: $('#nextDate')[0]
    });

    this.commonService.datePicker({
      field: $('#stopDate')[0]
    });

    this.$scope.$on('productList', (e, val) => {
      if (val) {
        this.recurring.invoice.items = val;
      }
    });

    this.$scope.$on('productSummary', (e, val) => {
      if (val) {
        this.summaryCalculated = true;
        this.summary = val;
      }
    });

    this.$scope.$on('selectedRecipient', (e, val) => {
      //setup placeholders
      this.recipient = {
        settings: {
          discount: 0
        },
        contact: {
          mobile: null
        }
      };

      if (val) {
        //copy data anyways for preview
        this.recipient = {
          customerNumber: val.customerNumber,
          name: val.name,
          contact: {
            address: val.address,
            email: val.email === '' ? null : val.email,
            phone: null,
            mobile: val.mobile === '' ? null : val.mobile,
            fax: null,
            web: null
          },
          organisation: {
            form: null,
            icd: val.icd === '' ? null : val.icd,
            number: val.organisationNumber === '' ? null : val.organisationNumber
          },
          settings: {
            discount: 0,
            creditDays: null,
            defaultShipment: 'EMAIL',
            currency: null
          },
          avtaleGiro: null,
          yourReference: null,
          customFields: [],
          comment: null,
          labels: val.labels || null
        };

        if (typeof val.number !== 'undefined') {
          this.recurring.invoice.recipient.number = val.number;
          this.recipient.contact.mobile = val.mobile;

          // update yourRef if empty
          if (this.recurring.invoice.yourReference === '' || this.recurring.invoice.yourReference === null) {
            this.recurring.invoice.yourReference = val.yourReference;
          }
        } else {
          this.recurring.invoice.recipient.number = null;
        }
      } else {
        this.recipient = null;
        this.recurring.invoice.recipient.number = null;
      }
    });

    this.$scope.$watch('$ctrl.recurring.invoice.accountNumber', (val, old) => {
      if (val && val !== old) {
        //update accountno on originator

        this.accountNumbers.forEach((item) => {
          if (val === item.number) {
            if (this.recurring.invoice.international) {
              this.recurring.invoice.international.bic = item.bic;
              this.recurring.invoice.international.iban = item.iban;
            } else {
              this.recurring.invoice.international = {
                bic: item.bic,
                iban: item.iban
              };
            }
            //do not display on page load
            if (old !== null) {
              this.Notification.success('BIC/IBAN er oppdatert');
            }
          }
        });

        this.updateGiro();
      }
    });

    this.$scope.$watchGroup([
      '$ctrl.recurring.shipment.dates.next',
      '$ctrl.recurring.dueDate',
      // '$ctrl.recurring.invoice.accountNumber',
      '$ctrl.recipient',
      '$ctrl.summary'
    ], (val, old) => {
      if (val !== old) {
        this.updateGiro();
      }
    });

    this.$scope.$watch('$ctrl.currency.code', (val) => {
      if (val === 'NOK') {
        this.recurring.invoice.currency = val;
        if (this.recurring.invoice.international) {
          this.recurring.invoice.international.exchangeRate = 1;
        } else {
          this.recurring.invoice.international = {
            exchangeRate: 1
          };
        }
      } else {
        this.currencies.forEach((currency) => {
          if (val === currency.code) {
            // update invoice
            this.recurring.invoice.currency = currency.code;

            if (this.recurring.invoice.international) {
              this.recurring.invoice.international.exchangeRate = currency.rate;
            } else {
              this.recurring.invoice.international = {
                exchangeRate: currency.rate
              };
            }
            return true;
          }
        }, this);
      }
    });

    this.$scope.$watch('$ctrl.SMSNotification', (val, old) => {
      if (val && val !== old) {
        this.recurring.shipment.smsMessage = this.$filter('defaultValue')(this.recurring.shipment.smsMessage, `${this.originator.name} har sendt deg en regning, se regningen på: `);
      }
    });

    this.loadOriginator();
    this.load();
  }

  getDataForPreview() {
    let clone = angular.copy(this.recurring.invoice);
    //those are required as implementation of recipient picker here will not return recipirnt object if data is not populated...
    if (this.recipient && this.recipient.name && this.recipient.contact.address.zip && this.recipient.contact.address.city) {
      clone.recipient = {
        customerNumber: this.recipient.customerNumber,
        name: this.recipient.name,
        address: this.recipient.contact.address,
        email: this.recipient.email,
        mobile: this.recipient.mobile,
        organisationNumber: this.recipient.organisationNumber
      };
    } else {
      clone.recipient = null;
    }
    return clone;
  }

  /**
   * Check the recipients number to be valid and show the message field if it is
   *
   * @param {String} mobile The number to check
   * @returns {Boolean}
   */
  isValidMobile(mobile) {
    return /^(?:4[015-8]|9\d)\d{6}$/.test(mobile);
  }

  calc(items) {
    let total = 0;

    items.forEach((i) => {
      total += i;
    });

    return total;
  }

  //when loading draft - update exchange rate to selected currency
  setExchangeRate() {
    this.currencies.forEach((currency) => {
      if (this.recurring.invoice.currency === currency.code) {
        if (this.recurring.invoice.international) {
          this.recurring.invoice.international.exchangeRate = currency.rate;
        } else {
          this.recurring.invoice.international = {
            exchangeRate: currency.rate
          };
        }
        return true;
      }
    }, this);
  }

  /**
   * Load originator settings for copy email and taxing options
   */
  loadOriginator() {
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
        if (this.recurring.invoice.international) {
          this.recurring.invoice.international.bic = resp.data.bankAccount.bic;
          this.recurring.invoice.international.iban = resp.data.bankAccount.iban;
        } else {
          this.recurring.invoice.international = {
            bic: resp.data.bankAccount.bic,
            iban: resp.data.bankAccount.iban
          };
        }
        this.recurring.shipment.smsMessage = this.$filter('defaultValue')(this.recurring.shipment.smsMessage, `${this.originator.name} har sendt deg en regning, se regningen på: `);

        this.accountNumbers = [];
        this.accountNumbers.push(
          {
            number: this.originator.bankAccount.number,
            bic: this.originator.bankAccount.bic,
            iban: this.originator.bankAccount.iban
          }
        );
        if (this.originator.bankAccount.additionalBankAccounts && this.originator.bankAccount.additionalBankAccounts.length > 0) {
          this.originator.bankAccount.additionalBankAccounts.forEach((a) => {
            this.accountNumbers.push(a);
          });
        }

        this.updateAccountNumberOnInvoice();
        this.originatorForDisplay = angular.copy(this.originator);

        this.updateGiro();
      });

    this.originatorService.settings()
      .then((resp) => {
        this.defaults = resp.data.defaults;

        if (typeof this.recurring.number === 'undefined' && this.recurring.shipment.copyEmail === null && resp.data.defaults.copy.suggest) {
          this.recurring.shipment.copyEmail = resp.data.defaults.copy.email;
        }

        this.taxEnabled = resp.data.defaults.totalIncludeMva;
        this.displayContractNumber = resp.data.defaults.displayContractNumber;
        this.displayProjectReference = resp.data.defaults.displayProjectReference;
      });
  }

  updateAccountNumberOnInvoice() {
    if (this.originator && !this.$filter('isEmptyObject')(this.originator)) {
      let found = this.accountNumbers.some(an => an.number === this.recurring.invoice.accountNumber);
      if (this.recurring.invoice.accountNumber === null || !found) {
        this.recurring.invoice.accountNumber = this.originator.bankAccount.number;
      }
    }
  }

  updateAccountOnOriginatorForDisplay() {
    if (this.recurring && this.originatorForDisplay) {
      this.originatorForDisplay.bankAccount.number = this.recurring.invoice.accountNumber;
    }
  }

  /**
   * Prepare new recurring or load an exisiting one
   */
  load() {
    // only if name is editable (new recurring)
    if (typeof this.number === 'undefined') {
      this.$scope.$watch('$ctrl.recurring.name', (val) => {
        if (val) {
          // new
          this.recurring.invoice.items[0] = {
            number: 1,
            quantity: 1,
            productCode: null,
            description: val + ' [month] [year]',
            unitPrice: null,
            discount: null,
            taxRate: this.originator.organisation.mvaregisteret ? 25 : 0,
            total: 0
          };
        }
      });
    } else {
      this.recurringService.get(this.number)
        .then((resp) => {
          this.recurring = resp.data;
          this.currency.code = this.recurring.invoice.currency;
          this.recurring.invoice.international = {};

          //load originator again to update bic/iban
          this.loadOriginator();

          if (this.currencies.length === 1) {
            this.commonService.getExchangeRates()
              .then((resp2) => {
                this.currencies = resp2;
                this.setExchangeRate();
              });
          } else {
            this.setExchangeRate();
          }

          if (this.recurring.shipment.smsMessage !== null && this.recurring.shipment.smsMessage !== '') {
            this.SMSNotification = true;
          }
        });
    }
  }

  allNetZero() {
    let sum = this.summary.net.reduce(function(a, b) { return a + b; }, 0);
    let x = (sum === 0);
    return x;
  }

  /**
   * Update the giro canvas
   */
  updateGiro() {
    this.canvasData = {
      invoiceNumber: '---',
      invoiceDate: moment(this.recurring.shipment.dates.next, 'YYYY-MM-DD').format('DD.MM.YY'),
      total: this.summary.total,
      dueDate: this.recurringService.calculateDueDate(this.recurring.dueDate, this.recurring.shipment.dates.next).format('DD.MM.YY')
    };

    if (this.originator && this.originator.contact && this.originator.bankAccount) {
      //update accountno on originator
      this.updateAccountOnOriginatorForDisplay();

      angular.extend(this.canvasData, {
        accountNumber: this.recurring.invoice.accountNumber,
        originator: {
          name: this.originator.name || '',
          address1: this.originator.contact.address.address1 || '',
          address2: this.originator.contact.address.address2 || '',
          zipCity: this.originator.contact.address.zip + ' ' + this.originator.contact.address.city || '',
          country: this.originator.contact.address.country || '',
          kid: this.originator.bankAccount.kid && this.originator.bankAccount.number === this.recurring.invoice.accountNumber || false
        }
      });
    }
    if (this.recipient && this.recipient.address) {
      angular.extend(this.canvasData, {
        recipient: {
          name: this.recipient.name || '',
          address1: this.recipient.address.address1 || '',
          address2: this.recipient.address.address2 || '',
          zipCity: this.recipient.address.zip + ' ' + this.recipient.address.city || '',
          country: this.recipient.address.country || ''
        }
      });
    }
  }

  /**
   * Prepare document for sending
   */
  process() {
    this.alert = {};

    //No longer do that because additional accountno might be selected
    // Update originator
    // if (this.recurring.invoice.international && this.recurring.invoice.international.bic && this.recurring.invoice.international.iban) {
    //   this.originator.bankAccount.iban = this.recurring.invoice.international.iban;
    //   this.originator.bankAccount.bic = this.recurring.invoice.international.bic;
    //
    //   this.originatorService.update(this.originator);
    // }

    if (!this.recurring.invoice.recipient || this.$filter('isEmptyObject')(this.recurring.invoice.recipient) || !this.recurring.invoice.recipient.number) {
      this.alert = {
        type: 'error',
        message: 'Mottager er påkrevd'
      };

      return;
    }

    let clone = angular.copy(this.recurring);

    if (clone.shipment.copyEmail === '') {
      this.recurring.shipment.copyEmail = null;
    }

    if (!this.SMSNotification) {
      delete this.recurring.shipment.smsMessage;
    }

    // cleanup items
    if (this.recurring.invoice.items.length) {
      this.recurring.invoice.items.forEach((item) => {
        item.unitPrice = this.$filter('defaultValue')(this.$filter('numberify')(item.unitPrice), null);
        item.quantity = this.$filter('defaultValue')(this.$filter('numberify')(item.quantity), null);
        return item;
      }, this);
    }

    if (this.recurring.number) {
      // update
      this.recurringService.update(this.recurring.number, this.recurring)
        .then(() => this.$location.path(`/fast-oppdrag/${this.recurring.number}`));
    } else {
      // new
      this.recurringService.save(this.recurring)
        .then((resp) => {
          let nr = resp.headers('location');

          if (nr) {
            this.$location.path(`/fast-oppdrag/${this.$filter('urlParser')(nr, 4)}`);
          } else {
            this.$location.path('/fast-oppdrag');
          }
        });
    }
  }

  changeLanguage() {
    swal({
      title: 'Bytt til norsk faktura?',
      text: 'Du vil miste det du har skrevet på denne regningen.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0c4d91',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Avbryt',
      closeOnConfirm: true
    }, (answer) => {
      if (answer) {
        if (this.originator.giroLayout) {
          this.$scope.$apply(() => this.$location.path('/fast-oppdrag/kladd'));
        } else {
          this.$scope.$apply(() => this.$location.path('/fast-oppdrag/utengiro/kladd'));
        }
      }
    });
  }

  /**
   * Save document
   */
  save() {
    if (this.recurring.name !== null && this.recurring.invoice.recipient.number === null) {
    // if (typeof this.recurring.number === 'undefined' && this.recurring.name !== null && this.recurring.invoice.recipient.number === null) {

      // save recipient first
      if (this.recipient && this.recipient.name) {
        this.recipientService.save(this.recipient)
          .then((resp) => {
            let nr = resp.headers('location');

            if (nr) {
              this.recurring.invoice.recipient.number = this.$filter('urlParser')(nr, 4);
              this.process();
            }
          });
      }
    } else {
      this.process();
    }
  }
}

RecurringInternationalDraft.$inject = ['$scope', '$filter', '$location', '$routeParams', 'commonService', 'recipientService', 'recurringService', 'originatorService', 'userService', 'Notification'];

const recurringInternationalDraft = {
  controller: RecurringInternationalDraft,
  templateUrl: 'recurring/draft-international.html'
};

angular
  .module('SendRegning')
  .component('recurringInternationalDraft', recurringInternationalDraft)
  .config(($routeProvider) => {
    $routeProvider
      .when('/fast-oppdrag/engelsk/kladd', {
        title: 'Fast oppdrag',
        template: '<recurring-international-draft />',
        noSidebar: true,
        secure: true
      })
      .when('/fast-oppdrag/engelsk/:number/regning', {
        title: 'Fast oppdrag',
        template: '<recurring-international-draft />',
        noSidebar: true,
        secure: true
      });
  });
